export default "__VITE_ASSET__DVVehOkq__"